import { legacyHookAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { selectAccessState, selectMainState } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'
import { AnswersPanel, MessagesPanel } from '@/deskUiSkeletons/Page/Panels'
import { LockedScreen } from '@/deskUiSkeletons/Blocking/LockedScreen'
import { EnterPinForm, LoadingOverlay, ShellOverlays } from '@/deskUiSkeletons/Shared/Overlays'
import { PinDialog } from '@/deskUiSkeletons/Shared/PinDialog'
import { PortalHome } from './PortalHome'
import { PortalMenu } from './PortalMenu'

export function PortalPage() {
  const { state } = useSubsStore()
  const mode = state.renderProjection.mode
  const main = selectMainState(state)
  const access = selectAccessState(state)
  const showHome = mode === 'msg'
  const showAnswers = mode === 'answers'
  const showMessages = mode === 'submsges'

  return (
    <>
      <ShellOverlays />
      <div {...legacyHookAttrs('page.root', 'md-portal-page min-h-screen w-full bg-white text-slate-900')}>
        <div {...legacyHookAttrs('page.table', 'min-h-screen w-full')}>
          <div {...legacyHookAttrs('page.header', 'h-14')}><div {...legacyHookAttrs('page.headerCell', 'h-14')} /></div>
          <main {...legacyHookAttrs('page.workspaceCell', 'mx-auto min-w-0 max-w-5xl px-4 pb-10')}>
            <article
              {...legacyHookAttrs('main.root', showHome ? 'block' : 'hidden')}
              style={{ display: showHome ? undefined : 'none' }}
            >
              <header {...legacyHookAttrs('main.header', 'hidden')} hidden aria-hidden="true">
                <span {...legacyHookAttrs('main.nameKeySign')}>@</span>
                <span {...legacyHookAttrs('main.authorFrame')}>{main.nameKey || main.codeKey || 'Portal'}</span>
                <div {...legacyHookAttrs('main.subjectRegion')}><span {...legacyHookAttrs('main.subjectText')}>{main.subject || 'Portal'}</span></div>
              </header>
              <section {...legacyHookAttrs('main.body')}>
                <div {...legacyHookAttrs('main.iframe')}>
                  {access.showUnlocked ? <PortalHome portalCodeKey={main.codeKey || ''} /> : <LockedScreen />}
                </div>
                <div {...legacyHookAttrs('main.editMount', 'hidden')} hidden aria-hidden="true" />
              </section>
            </article>
            <div aria-hidden={!showAnswers} style={{ display: showAnswers ? undefined : 'none' }}><AnswersPanel /></div>
            <div aria-hidden={!showMessages} style={{ display: showMessages ? undefined : 'none' }}><MessagesPanel /></div>
          </main>
          <div {...legacyHookAttrs('page.footer', 'h-8')} />
        </div>
      </div>
      <PortalMenu />
      <EnterPinForm />
      <LoadingOverlay />
      <PinDialog />
    </>
  )
}
